<template>
  <div>
    <notification-form @submit="sendNotification" />
  </div>
</template>
<script>
import NotificationForm from './components/NotificationForm.vue'
export default {
  methods: {
    sendNotification(data) {
      this.$store.dispatch('Users/sendNotification', data)
    },
  },
  components: {
    NotificationForm,
  },
}

</script>
